import React from "react";
import { CopyButtonTooltip } from "../components/copy-button-tooltip";
import { Button } from "../components/ui/button";
import { ConversationOverview } from "./types";

// Conversations created while titles were auto-generated were saved with this
// placeholder instead of the other person's name.
const PLACEHOLDER_TARGET_NAME = "the other person";

export const hasRealTargetName = (targetName?: string) =>
  Boolean(targetName) && targetName !== PLACEHOLDER_TARGET_NAME;

export const getConversationName = (conversation: ConversationOverview) =>
  hasRealTargetName(conversation.targetName)
    ? conversation.targetName
    : conversation.title || "New conversation";

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const parseContent = (content: string): (string | JSX.Element)[] => {
  const regex = /\{\{(.*?)\}\}(\n+)?/g;
  const parts = [];
  let lastIndex = 0;

  let match;
  while ((match = regex.exec(content)) !== null) {
    const [fullMatch, innerContent] = match;
    const matchStart = match.index;

    // Add plain text before the match, trimming trailing newlines
    if (lastIndex < matchStart) {
      const textContent = content
        .substring(lastIndex, matchStart)
        .replace(/\n+$/, "");
      if (textContent) {
        parts.push(
          <span style={{ whiteSpace: "pre-line" }}>{textContent}</span>
        );
      }
    }

    // Remove extra quotes if they exist at start and end
    const cleanContent = innerContent.trim().replace(/^"(.*)"$/, "$1");

    // Add the styled span for the match, including the curly braces
    parts.push(
      <div key={matchStart} className="flex gap-2 items-center my-4">
        <div
          className="py-2 px-4 rounded-3xl bg-gradient-to-b from-gray-700 from-50% to-gray-800 text-white sm:max-w-[50%] max-w-[75%]"
          style={{ whiteSpace: "pre-line" }}
        >
          {cleanContent}
        </div>
        <CopyButtonTooltip textToCopy={cleanContent} />
      </div>
    );

    lastIndex = regex.lastIndex;
  }

  // Add any remaining plain text after the last match
  if (lastIndex < content.length) {
    const textContent = content.substring(lastIndex);
    if (textContent) {
      parts.push(<span style={{ whiteSpace: "pre-line" }}>{textContent}</span>);
    }
  }

  return parts;
};